;$(function() {
	// return;
	// Init gallery slider
	// window.gallerySlider = new Swiper('#gallery-swiper-id', {
	// 	navigation: {
	// 		nextEl: '.gallery__button_next.gal-images',
	// 		prevEl: '.gallery__button_prev.gal-images',
	// 	}
	// });

	// // Init gallery pagination slider
	// var galleryThumbs = new Swiper('#gallery-thumbs-id', {
	// 	slidesPerView: 6,
	// 	slidesPerColumn: 2,
	// 	spaceBetween: 5,
	// 	slidesPerColumnFill: 'row',
	// 	navigation: {
	// 		nextEl: '.gallery-thumbs__button_next.gal-images',
	// 		prevEl: '.gallery-thumbs__button_prev.gal-images',
	// 	},
	// 	breakpoints: {
	// 		449: {
	// 			slidesPerView: 3,
	// 			slidesPerColumn: 2,
	// 		}
	// 	}
	// });

	// // Gallery controlls
	// $('#gallery-thumbs-id .image-pagination__item').eq(0).addClass('image-pagination__item_active');

	// gallerySlider.on('slideChange', function () {
	// 	$('#gallery-thumbs-id .image-pagination__item_active').removeClass('image-pagination__item_active');
	// 	$('#gallery-thumbs-id .image-pagination__item').eq(this.realIndex).addClass('image-pagination__item_active');
	// });

	// $('.gallery .image-pagination__item').click(function() {
	// 	let targetIndex = $('.image-pagination__item').index(this);
	// 	$(this).parents('.gallery').find('.image-pagination__item_active').removeClass('image-pagination__item_active');
	// 	$(this).addClass('image-pagination__item_active');
	// 	gallerySlider.slideTo(targetIndex);
	// });

	// Init simple sliders
	function initSimpleSlider() {
		let sliderId = $(this).attr('id') || 'simple-slider_id_' + simpleSliders.length;
		$(this).attr('id', sliderId);
		let tabletVerticalBreakpoint = {
			slidesPerView: $(this).data('columns') > 2 ? 2 : 1,
			slidesPerColumn: $(this).data('rows') || 1,
			slidesPerGroup: $(this).data('grouped') ? ($(this).data('columns') > 2 ? 2 : 1) : 1
		};
		let mobileBreakpoint = {
			slidesPerView: 1,
			slidesPerColumn: $(this).data('rows') || 1,
			slidesPerGroup: 1
		};

		let slider = new Swiper('#' + sliderId, {
			slidesPerView: $(this).data('columns') || 1,
			slidesPerColumn: $(this).data('rows') || 1,
			spaceBetween: $(this).data('gap') || 0,
			slidesPerGroup: $(this).data('grouped') ? $(this).data('columns') : 1,
			navigation: {
				prevEl: '#' + sliderId + ' .simple-navigation__item_left',
				nextEl: '#' + sliderId + ' .simple-navigation__item_right',
				disabledClass: 'simple-navigation__item_disabled'
			},
			pagination: {
				el: '#' + sliderId + ' .simple-slider__pagination',
				type: 'bullets',
				clickable: true,
				bulletClass: 'simple-pagination__item',
				bulletActiveClass: 'simple-pagination__item_active',
				renderBullet: function (index, className) {
					return '<div class="' + className + '"><div class="simple-pagination__line"></div></div>';
				}
			},
			breakpoints: {
				1023: tabletVerticalBreakpoint,
				767: mobileBreakpoint
			}
		});

		slider.on('slideChange', function () {
			let currentSlide = this.$el.find('.simple-pagination__item_active').index() + 1;
			this.$el.find('.simple-navigation__current').text(currentSlide);
		});

		simpleSliders.push({
			id: sliderId,
			slider: slider
		});

		if ($(this).find('.simple-navigation__counter').length) {
			let currentSlide = $(this).find('.simple-pagination__item_active').index() + 1;
			let totalSlide = $(this).find('.simple-pagination__item').length;
			$(this).find('.simple-navigation__current').text(currentSlide);
			$(this).find('.simple-navigation__total').text(totalSlide);
		}
	}

	var simpleSliders = [];

	$('.simple-slider').each(initSimpleSlider);
});